import BackButton from './back_button'

export default class LangMenu {
  constructor(elLangMenu, elMenuMobile){
    this.langmenu = elLangMenu
    this.menuMobile = elMenuMobile

    this.reset()
    this.initEvents()
  }

  initEvents(){
    this.langmenu.find('.lang_cust_ddl li.active span').click(() => {
      this.menuMobile.addClass('mhg-expanded-submenu')
      this.langmenu.addClass('submenu-mobile-open')

      this.backButton = new BackButton(this.menuMobile.parent(), () => {
        this.reset()
      })
    })
  }

  reset(){
    this.menuMobile.removeClass('mhg-expanded-submenu')
    this.langmenu.removeClass('submenu-mobile-open')
  }

  destroy(){
    this.reset()

    if(this.backButton)
      this.backButton.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/custom_menu/langmenu.js